package component

import com.github.quillraven.fleks.*
import com.soywiz.korge.box2d.*
import org.jbox2d.common.*
import org.jbox2d.dynamics.*

class PhysicComponent(
    val impulse: Vec2 = Vec2(),
    val body: Body,
    val vXmax: Float = 0f,
    val vYmax: Float = 0f
) : Component<PhysicComponent> {

    val prevPos = Vec2(body.position.x, body.position.y)

    var applyDelta = false
    var posXd: Float = 0f
    var posYd: Float = 0f
    var vXd: Float = 0f
    var vYd: Float = 0f

    override fun type() = PhysicComponent

    companion object : ComponentType<PhysicComponent>() {

        val onAddPhysic: ComponentHook<PhysicComponent> = { entity, physic ->
            physic.body.userData = entity
        }

        val onRemovePhysic: ComponentHook<PhysicComponent> = { _, physic ->
            val body = physic.body
            body.world.destroyBody(body)
            body.userData = null
            body.view?.removeFromParent()
        }
    }
}

class PlayerPhysicState(
    val body: Body
) {

    var coinsCount = 0
        private set
    var diamonds1Count = 0
        private set
    var diamonds2Count = 0
        private set
    var diamonds3Count = 0
        private set

    private val groundContacts = mutableSetOf<Fixture>()
    private val wallLeftContacts = mutableSetOf<Fixture>()
    private val wallRightContacts = mutableSetOf<Fixture>()
    private val trapContacts = mutableSetOf<Fixture>()

    fun addCoin(coin: CoinComponent) {
        when (coin.cashType) {
            CashTypes.COIN -> coinsCount++
            CashTypes.DIAMOND_1 -> diamonds1Count++
            CashTypes.DIAMOND_2 -> diamonds2Count++
            CashTypes.DIAMOND_3 -> diamonds3Count++
        }
        coin.isCollected = true
    }

    fun addGroundContact(fixture: Fixture) {
        groundContacts += fixture
    }

    fun removeGroundContact(fixture: Fixture) {
        groundContacts -= fixture
    }

    fun addWallLeftContact(fixture: Fixture) {
        wallLeftContacts += fixture
    }

    fun removeWallLeftContact(fixture: Fixture) {
        wallLeftContacts -= fixture
    }

    fun addWallRightContact(fixture: Fixture) {
        wallRightContacts += fixture
    }

    fun removeWallRightContact(fixture: Fixture) {
        wallRightContacts -= fixture
    }

    fun addTrapContact(fixture: Fixture) {
        trapContacts += fixture
    }

    fun removeTrapContact(fixture: Fixture) {
        trapContacts -= fixture
    }

    val isGrounded: Boolean
        get() = groundContacts.isNotEmpty()

    val isOnLeftWall: Boolean
        get() = wallLeftContacts.isNotEmpty()

    val isOnRightWall: Boolean
        get() = wallRightContacts.isNotEmpty()

    val isOnWall: Boolean
        get() = isOnRightWall || isOnLeftWall

    val isOnTrap: Boolean
        get() = trapContacts.isNotEmpty()

    fun resetTraps() = trapContacts.clear()

    val traps: Set<Fixture> = trapContacts
}
